import DataCombobox from "@/components/VuetifyWrappers/DataCombobox.vue";
import DataAutocomplete from "@/components/VuetifyWrappers/DataAutocomplete.vue";

export default {
  addComponents(Vue) {
    Vue.component("VcDataCombobox", DataCombobox);
    Vue.component("VcDataAutocomplete", DataAutocomplete);
  }
};
